import isEqual from "react-fast-compare";

export class ComparisonHelper {
  public static isDeepEqual<T1 = any, T2 = any>(a: T1, b: T2): boolean {
    return isEqual(a, b);
  }
}
